import { Box, Dialog, DialogClassKey, DialogTitle, ClassNameMap } from '@mui/material';
import { Button } from '../../Button';
import { useDeleteModalStyles } from './styles';
import { ModalProvider } from '../modal.context';
import { useCallback, useMemo } from 'react';

export type DeleteModalProps = {
  open: boolean;
  title: string;
  cancelButtonText?: string;
  classes?: Partial<ClassNameMap<DialogClassKey | 'disabled' | 'title' | 'subtitle'>>;
  disabled?: boolean;
  loading?: boolean;
  onClose: (shouldDelete: boolean) => void;
};

export const DeleteModal: React.VFC<DeleteModalProps> = ({
  open,
  title,
  onClose,
  cancelButtonText,
  disabled,
  loading
}) => {
  const { classes } = useDeleteModalStyles();

  const handleClose = useCallback(() => {
    if (disabled || loading) {
      return;
    }

    onClose(false);
  }, [ disabled, loading, onClose ]);

  const handleCancel = useCallback(() => {
    onClose(false);
  }, [ onClose ]);

  const handleConfirm = useCallback(() => {
    onClose(true);
  }, [ onClose ]);

  const contextValue = useMemo(() => ({
    loading: loading,
    disabled: disabled,
  }), [ loading, disabled ]);

  return (
    <ModalProvider value={contextValue}>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth classes={{ paperWidthXs: classes.paperWidthXs }}>
        <DialogTitle className={classes.textAlignCenter}>
          {title}
        </DialogTitle>
        <Box p={2} className={classes.deleteModalActions}>
          <Button color="inherit" onClick={handleCancel} disabled={loading} fullWidth>
            {cancelButtonText ?? 'Cancel'}
          </Button>
          <Button
            variant="contained"
            className={classes.deleteButton}
            onClick={handleConfirm}
            disabled={loading}
            fullWidth
          >
            Delete
          </Button>
        </Box>
      </Dialog>
    </ModalProvider>
  );
};
